<template>
  <v-currency-field
    ref="input"
    v-bind="attrs"
    :value="getVal"
    @input="$emit('input', $event)"
  ></v-currency-field>
</template>

<script>
const formatter = new Intl.NumberFormat("pt-BR");

export default {
  name: "MyVCurrencyField",
  props: {
    label: {
      type: String,
      required: false,
      default: () => undefined,
    },
    value: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },
  computed: {
    attrs() {
      // eslint-disable-next-line
      const { value, ...attrs } = this.$attrs; // all but input event
      return attrs;
    },
    getVal() {
      if (this.$refs.input === undefined) {
        return formatter.format(this.value);
      } else {
        return this.value;
      }
    },
  },
};
</script>